const GlobaRecognitionValue = {
    RecognitionValue: "",
};
module.exports = GlobaRecognitionValue;
